<template>
		<div class="list--view">           
            <div class="single--list-view single--list-view-employees">
                <vs-select
                    class="selectExample"
                    v-model="selectGrades"
                    @input="gradeSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsGrades" />
                </vs-select>
            </div>

        </div>
</template>

<script>
    export default {
        data () {
            return {
                selectGrades: new URL(location.href).searchParams.get('grade') == null ? '' : new URL(location.href).searchParams.get('grade'),
                optionsGrades:[
                	{value: '', label: 'Tutti', isSelected: true },
                    {value: '1', label: '1', isSelected: false },
                    {value: '2', label: '2', isSelected: false },
                    {value: '3', label: '3', isSelected: false },
                    {value: '4', label: '4', isSelected: false },
                    {value: '5', label: '5', isSelected: false },
                    {value: '6', label: '6', isSelected: false },
                    {value: '7', label: '7', isSelected: false },
                    {value: '8', label: '8', isSelected: false },
                    {value: '9', label: '9', isSelected: false },
                    {value: '10', label: '10', isSelected: false },
                ],


            }
        },
        methods: {
            gradeSelected(selectedOption, id) {
                location.href = app.__vue__.addParam("grade", selectedOption);
            },

        },

    }
</script>
